import React from 'react';
import { Button, Col, Container, Row, Form, Stack, Table } from 'react-bootstrap';
import '../../App.css';
import utils from '../../utils';
import LoadingSpinner from "../../comp/gen/LoadingSpinner";
import UserAuthRequired from "../../comp/gen/UserAuthRequired";
import AuthService from '../../services/auth-service';
import yaml from 'js-yaml'; // Importa la libreria js-yaml

export default class MP_CALIBCONV extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      working: 0,
      selectedFile: null,
      kMolt: null,
      corrPerc: null,
      yamlFile: null,
      ccalFile: null,
    };
  }
  handleFileChange = (event) => { this.setState({ selectedFile: event.target.files[0] }) }
  handleConvert = async () => {
    const { selectedFile } = this.state;
    if (!selectedFile) {
      alert("Please select a file first.");
      return;
    }

    this.setState({ working: 1 });

    try {
      const fileReader = new FileReader();
      fileReader.onload = async () => {
        const base64Content = fileReader.result.split(',')[1]; // Extract base64 content
        const response = await AuthService.ecuConvertCalib(base64Content);

        if (response.is_valid) {
          const { kMolt, corrPerc, yaml: yamlBase64, ccal } = response.value;
          const fileName = selectedFile.name.split('.')[0];

          // Decodifica il contenuto YAML
          const decodedYaml = atob(yamlBase64); // Decodifica base64 in stringa
          const yamlObject = yaml.load(decodedYaml); // Analizza il contenuto YAML puro

          // Cerca gli elementi richiesti in CalibrationItems
          const calibrationItems = yamlObject.CalibrationItems || [];
          const bpKPinjTimeItem = calibrationItems.find(item => item.Name === "EE_GInjTimeCalc.BP_K_PInjTime");
          const bpKRpmItem = calibrationItems.find(item => item.Name === "EE_GInjTimeCalc.BP_K_Rpm");

          // Recupera i valori PhysValues
          const bpKPinjTime = bpKPinjTimeItem ? bpKPinjTimeItem.PhysValues : undefined;
          const bpKRpm = bpKRpmItem ? bpKRpmItem.PhysValues : undefined;

          // Stampa i valori nella console
          console.log("EE_GInjTimeCalc.BP_K_PInjTime:", bpKPinjTime);
          console.log("EE_GInjTimeCalc.BP_K_Rpm:", bpKRpm);

          // Trasforma corrPerc in una matrice 12x12
          const corrPercMatrix = [];
          for (let i = 0; i < corrPerc.length; i += 12) {
            corrPercMatrix.push(corrPerc.slice(i, i + 12));
          }

          this.setState({
            kMolt,
            corrPerc: corrPercMatrix, // Usa la matrice trasformata
            yamlFile: { name: `${fileName}.ccal-yaml`, content: yamlBase64 }, // Corretto il nome del file
            ccalFile: { name: `${fileName}.ccal`, content: ccal },
            bpKRpm, // Salva i valori di bpKRpm per le intestazioni delle colonne
            bpKPinjTime, // Salva i valori di bpKPinjTime per le intestazioni delle righe
            working: 0,
          });
        } else {
          alert(response.message || "Conversion failed.");
          this.setState({ working: 0 });
        }
      };
      fileReader.readAsDataURL(selectedFile);
    } catch (error) {
      console.error("Error during conversion:", error);
      alert("An error occurred during the conversion.");
      this.setState({ working: 0 });
    }
  }
  downloadFile = (file) => {
    const link = document.createElement('a');
    link.href = `data:application/octet-stream;base64,${file.content}`;
    link.download = file.name;
    link.click();
  }
  render() {
    if (!this.props.authStatus.completed) return <LoadingSpinner />;
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />;
    if (!utils.userHasRole(this.props.authStatus.user, "CALCONV")) return <UserAuthRequired notallowed />

    const { working, kMolt, corrPerc, yamlFile, ccalFile, bpKRpm, bpKPinjTime } = this.state;
    const buttonsEnabled = !(working === 1);
    return (
      <>
        <Container>
          <Row style={{ marginTop: "15px" }}>
            <Col>
              <Row>
                <Stack direction='horizontal' gap={3}>
                  <Form.Control
                    type="file"
                    //accept=".bin,.calib"
                    onChange={this.handleFileChange}
                    disabled={!buttonsEnabled}
                  />
                  <Button
                    variant="primary"
                    onClick={this.handleConvert}
                    disabled={!buttonsEnabled}
                  >
                    Convert
                  </Button>
                </Stack>
              </Row>
              {kMolt !== null && (
                <>
                  <h5 style={{ marginTop: "20px" }}>EE_MinCal.current_corr: <strong>{kMolt}</strong></h5>
                  {bpKRpm && bpKPinjTime && corrPerc && (
                    <>
                      <h5 style={{ marginTop: "20px" }}>EE_GInjTimeCalc.TBL_K0</h5>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>{" "}</th> {/* Cella vuota per l'angolo in alto a sinistra */}
                            {bpKRpm.map((rpmVal, idx) => (
                              <th key={idx} style={{ textAlign: "right" }}>{rpmVal}</th> // Intestazioni delle colonne allineate a destra
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {corrPerc.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              <th style={{ textAlign: "right" }}>{bpKPinjTime[rowIndex]}</th> {/* Intestazioni delle righe allineate a destra */}
                              {row.map((value, colIndex) => (
                                <td key={colIndex} style={{ textAlign: "right" }}>{value}</td> // Valori della matrice allineati a destra
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>
                  )}
                  <Stack direction='horizontal' gap={3}>
                    {yamlFile && (
                      <Button
                        variant="success"
                        onClick={() => this.downloadFile(yamlFile)}
                      >
                        Download CCAL-YAML
                      </Button>
                    )}
                    {ccalFile && (
                      <Button
                        variant="success"
                        onClick={() => this.downloadFile(ccalFile)}
                      >
                        Download CCAL
                      </Button>
                    )}
                  </Stack>                  
                </>
              )}
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
